// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n.offline { color: red; }\n.online { color: green; }\n.last {font-size:xx-small; color: #FFFFFF;}\n.battery {font-size:xx-small}\n.fix { background-color: #3cb371 }\n.dfix { background-color: #ffa500  }\n", ""]);
// Exports
module.exports = exports;
